module.exports = __webpack_public_path__ + "img/facebook.a6a36fca.svg";